const paymentModal = {
  'paymentModal.title': 'Pagar',
  'paymentModal.splitInvoice.title': 'Parcelamento',
  'paymentModal.inputLabel': 'Valor',
  'paymentModal.splitInvoice.inputLabel': 'Valor para {bold}?',
  'paymentModal.splitInvoice.inputLabel02': 'pagamento da entrada',
  'paymentModal.splitInvoice.subtitle': 'Número de parcelas {value} restantes',
  'paymentModal.generatePayment': 'Gerar boleto',
  'paymentModal.payStatement': 'Pagar conta',
  'paymentModal.payStatement.successful': 'Conta paga com sucesso.',
  'paymentModal.splitInvoice': 'Parcelar fatura',
  'paymentModal.validUntil': 'Vencimento',
  'paymentModal.instructions':
    'Utilize o número do código abaixo para pagar até a data de vencimento.',
  'paymentModal.emptyState': 'Não há nenhum valor para pagamento.',
  'paymentModal.copied': 'Copiado!',
  'paymentModal.copy': 'Copiar código',
  'paymentModal.sendBySMS': 'Enviar por SMS',
  'paymentModal.sentBySMS': 'SMS enviado!',
  'paymentModal.sendByEmail': 'Enviar por e-mail',
  'paymentModal.sentByEmail': 'Email enviado!',
  'paymentModal.lowerThanMinimumDisclaimer':
    'Atenção! Você pode pagar abaixo do valor mínimo, mas sua conta ficará em atraso.',
  'paymentModal.errorState':
    'Ocorreu um erro ao consultar os dados de pagamento.',
  'paymentModal.confirm': 'Confirmar',
  'paymentModal.advance': 'Próximo',
  'paymentModal.closedValue': 'Valor total',
  'paymentModal.splitInvoice.rates': 'Taxas',
  'paymentModal.splitInvoice.total': 'Total',
  'paymentModal.splitInvoice.tax': 'IOF',
  'paymentModal.splitInvoice.upfront': 'Entrada',
  'paymentModal.splitInvoice.totalRemaining': 'Total restante',
  'paymentModal.splitInvoice.lastDateInfo': 'Última parcela vence em',
  'paymentModal.splitInvoice.outcomeTitle':
    'Solicitação de parcelamento de fatura concluída.',
  'paymentModal.splitInvoice.outcomeSubtitle':
    'Para confirmar a contratação do parcelamento, o pagamento da entrada precisa ser feito até a data de vencimento. Utilize o número do código abaixo.',
  'paymentModal.splitInvoice.noInstallmentOptions':
    'Não há opções de parcelamento',
  'paymentModal.error.biggerValue':
    'Valor inserido é maior que o valor total da fatura',
  'paymentModal.payment.agreement': 'Acordo fatura',
  'paymentModal.payment.entrance': 'Valor da entrada',
  'paymentModal.payment.entrance.date': 'Data para pagamento da entrada',
  'paymentModal.agreement.contemplated': 'Faturas',
  'paymentModal.agreement.interests.discount': 'Desconto',
  'paymentModal.payment.installments': 'Número de parcelas ',
  'paymentModal.payment.installments.last': 'Última parcela em: ',
  'paymentModal.payment.installments.summary.title': 'Confira o resumo',
  'paymentModal.payment.installments.summary.entranceDate':
    'Data da entrada: {date}',
  'paymentModal.payment.installments.summary.dates':
    'Vencimento das parcelas: {day}',
  'paymentModal.payment.installments.summary.entranceValue':
    'Valor da entrada: {value}',
  'paymentModal.payment.installments.summary.values': 'Resumo',
  'paymentModal.payment.installments.summary.totalValue': 'Valor parcelado',
  'paymentModal.payment.installments.summary.interest':
    'Taxa de juros ({tax}% ao mês)',
  'paymentModal.payment.installments.summary.taxes': 'Taxas',
  'paymentModal.payment.installments.summary.totalInInstallments':
    'Total a ser parcelado',
  'paymentModal.payment.installments.summary.final':
    'Parcelamento final {payments} {value}',
  'paymentModal.payment.installments.summary.legalTextCet':
    'Custo efetivo total(CET) de {cet_month}% ao mês e de {cet_anual}% ao ano.',
  'paymentModal.payment.installments.summary.legalTextDaily':
    'IOF de {rate_daily}% mais taxa diária de {iof_daily}% ao dia',
  'paymentModal.payment.installments.summary.legalTextInterests':
    'Taxa de juros de {interests_month}% ao mês e de {interests_anual}% ao ano.',
  'paymentModal.payment.installments.error':
    'Ocorreu um erro, por favor tente novamente',
  'paymentModal.payment.installments.sucess': 'Acordo gerado com sucesso',
  'paymentModal.payment.installments.errorDueDates':
    'Não há datas de pagamento disponiveis para tentar um acordo. Tente novamente em alguns dias.',
  'paymentModal.warningBankslip':
    'Lembre-se: o não pagamento total até a data de vencimento implica em cobrança de juros, multa, mora e IOF.',
  'paymentModal.invoice.agreement':
    'Clicando em “Confirmar” o Acordo será concluído, os cartões físico e virtuais ficarão bloqueados para uso.',
  'paymentModal.invoice.agreementWaringBanksLip':
    'Informar ao cliente que o parcelamento (acordo) será efetivado após o pagamento desse boleto',
};

export default paymentModal;
